<template>
  <div class="space-bottom-1 space-top-1">
    <div class="flex justify-center gap-1 align-center">
      <div v-if="exitButtonText">
        <input @click.stop="$emit('hide-modal')" class="exit-button" type="button" :value="exitButtonText">
      </div>
      <div v-if="backButtonText">
        <input @click.stop="$emit('back')" class="back-button" type="button" :value="backButtonText">
      </div>
      <div>
          <input v-if="inputValid" @click.stop="$emit('progress')" class="form-button" type="button" :value="buttonText">
          <input v-else class="form-button" type="button" :value="buttonText" disabled>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    props: {
      inputValid: {
        type: Boolean,
        required: true,
        default: true
      },
      buttonText: {
        type: String,
        required: true,
        default: "Submit"
      },
      exitButtonText: {
        type: String,
        required: false
      },
      backButtonText: {
        type: String,
        required: false
      }
    }
}
</script>

<style lang="scss" scoped>
  .form-button {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 15px;
    width: 200px;
    height: 48px;
    color: #fff;
    background: #0384FB;
    border-radius: 24px;
    border: none;

    &:hover {
        background: #0384FB;
    }

    &:disabled {
      background: #0384FB;
      opacity: 0.4;
    }
  }


  .exit-button {
      padding: 0px;
      background: #fff;
      border-radius: 24px;
      color: #0384FB;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 700;
      align-content: center;
      font-size: 20px;
      line-height: 15px;
      width: 200px;
      height: 48px;
      

      &:hover {
          box-shadow: none;
      }
  }

  .back-button {
      padding: 0px;
      background: #fff;
      border-radius: 24px;
      border: 2px solid #0384FB;
      color: #0384FB;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 700;
      align-content: center;
      font-size: 20px;
      line-height: 15px;
      width: 200px;
      height: 48px;
      

      &:hover {
          box-shadow: none;
      }
  }
</style>